import KbvOddsStatus from "@/components/KbvOddsStatus";
import { colorOddsChanges } from "@/utils/matchInfo";

export default function OddsPill({ label, odds = "1.91", trend = "unchanged" }) {
  return (
    <div className="flex rounded-full overflow-hidden border border-[var(--theme-border)] h-7 w-[90px] bg-[var(--theme-foreground)]">
      <span className="px-1.5 py-0.5 text-[10px] text-[var(--theme-text-muted)] whitespace-nowrap flex items-center w-[35px] shrink-0">
        {label}
      </span>
      <div className="px-1 py-0.5 flex-1 flex items-center justify-center gap-0.5 min-w-[50px]">
        <KbvOddsStatus trend={trend} />
        <span className={`text-xs font-medium text-[var(--theme-text)] ${colorOddsChanges(trend)}`}>
          {odds}
        </span>
      </div>
    </div>
  );
}